module.exports = __webpack_public_path__ + "static/img/wuchao.2e81d95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/wuchao.jpg
// module id = 4XR2
// module chunks = 1